// Login component for the user created by Likesh
// return the user object if the user is logged in, otherwise return null
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../style.css";
import { ReactComponent as LoadingIcon } from '../../../src/cpanel-loading.svg';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../config";

export default function Login({handleIsEnquiry, isEnquiry,handleRegister}) {
    const [formData, setformData] = useState({
        userName: "",
        password: "",
        otp: "",
        resendOtp: ""
    });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [resendTimer, setResendTimer] = useState(45);
    const [isResendMobileOtp, setIsResendMobileOtp] = useState(false);
    const [otpLoader, setOtpLoader] = useState(false);

    const navigation = useNavigate("");


    useEffect(() => {
        if (isOtpSent && resendTimer > 0) {
            const timer = setInterval(() => {
                setResendTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else if (resendTimer === 0) {
            setIsResendMobileOtp(true);
        }
    }, [isOtpSent, resendTimer]);

    //MODIFIED BY SHAHIN
    const validate = () => {
        const newErrors = {
            userName: formData.userName === '' ? 'User Name is required' : '',
            password: formData.password === '' ? 'Password is required' : '',
            otp: formData.otp === '' ? 'OTP is required' : '',
        };

        setErrors(newErrors);

        return !Object.values(newErrors).some((error) => error !== '');
    };

    const handleChange = (e) => {
        let { id, value } = e.target;
        if (id == "userName") value = value.slice(0, 13);
        else if (id == "otp") {
            value = value.toString().replace(/[^0-9]/g, "");
            value = value.toString().trim().slice(0, 4);
        }

        setformData({
            ...formData,
            [id]: value
        });

        setErrors({
            ...errors,
            [id]: value.trim() === '' ? `${id.charAt(0).toUpperCase() + id.slice(1)} is required` : ''
        });
    };

    useEffect(() => { }, [submitted, setSubmitted]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (isOtpSent) return handleVerifyOtp()
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/auth/login/userLoginWithoutCmpanyCode`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userName: formData.userName,
                    password: formData.password
                })
            });
            const result = await res.json();
            if (res.ok) {
                console.log(result);
                localStorage.setItem('token', result.token);
                localStorage.setItem('role', result.role);
                localStorage.setItem('login', JSON.stringify(true));
                setIsOtpSent(true)
                setResendTimer(45);
                setIsResendMobileOtp(false);
            }
            else if (res.status === 401) {
                if (result.error === "Company Inactive") {
                    toast.error("Company Inactive")
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: result.error, life: 3000 });
                }
                else if (result.error === "User Inactive") {
                    toast.error("User Inactive")
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: result.error, life: 3000 });
                }
                setErrors(prevErrors => ({
                    ...prevErrors,
                    userName: result.error === "Invalid username" ? "Invalid User Name" : prevErrors.userName,
                    password: result.error === "Invalid password" ? "Invalid Password" : prevErrors.password
                }));
            }
        }
        catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/auth/login/verifyOTP`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: localStorage.getItem("token"),
                    otp: formData.otp,
                })
            });
            const result = await res.json();
            if (res.ok) {
                console.log(result);
                window.open('/panel/dashboard', '_blank');
                setTimeout(() => {
                    window.location.reload();
                }, 100);
                toast.success("Login successful.")
            }

            else if (res.status === 401) {
                if (result.error === "Company Inactive") {
                    toast.error("Company Inactive")
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: result.error, life: 3000 });
                }
                else if (result.error === "User Inactive") {
                    toast.error("User Inactive")
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: result.error, life: 3000 });
                }
                setErrors(prevErrors => ({
                    ...prevErrors,
                    otp: result.error === "Invalid OTP" ? "Invalid OTP" : prevErrors.otp,
                }));
            }
        }
        catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    }

    const handleResendOtp = async () => {
        setOtpLoader(true);

        // alert(formData.mobile)
        try {
            const res = await fetch(`${API_URL}/auth/login/resendMobileOtp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token: localStorage.getItem("token"),
                    resendOtp: formData.resendOtp || "",

                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("OTP sent successfully.")
                setResendTimer(45);
                setIsResendMobileOtp(false);
            } else {
                toast.error("Failed to resend OTP:", result.message || "Unknown error")
                console.error("Failed to resend OTP:", result.message || "Unknown error");
            }

        } catch (error) {
            toast.error("Error resending OTP")
            console.error("Error resending OTP:", error);

        } finally {
            setOtpLoader(false);

        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            id="contact-form"
            className="default-form"
        >
            <div className="row clearfix">
                {/* modified by shahin */}
                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                    <input
                        id="userName"
                        type="text"
                        name="userName"
                        placeholder="Username *"
                        value={formData.userName}
                        onChange={handleChange}
                        style={
                            errors.userName ? { border: "1px solid red" } : {}
                        }
                    />
                    {errors.userName && (
                        <span className="error" style={{ color: "red" }}>
                            {errors.userName}
                        </span>
                    )}
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                    <input
                        type="text"
                        name="password"
                        id="password"
                        placeholder="password *"
                        value={formData.password}
                        onChange={handleChange}
                    />
                    {errors.password && (
                        <span className="error" style={{ color: "red" }}>
                            {errors.password}
                        </span>
                    )}
                </div>
                {isOtpSent &&
                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                        <input
                            type="text"
                            name="otp"
                            id="otp"
                            placeholder="Otp *"
                            value={formData.otp}
                            onChange={handleChange}
                        />
                        {errors.otp && (
                            <span className="error" style={{ color: "red" }}>
                                {errors.otp}
                            </span>
                        )}
                    </div>}

                {isOtpSent && isResendMobileOtp && (
                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                         {otpLoader ? <LoadingIcon style={{
                    height: 35,
                    marginTop: 2,
                    width: 50
                  }} /> :
                    <button
                      type="button"
                      style={otpLoader ? {} : {
                        color: "blue",
                        fontSize: 14,
                        borderBottom: '1px solid blue',
                      }}
                      onClick={handleResendOtp}
                      >
                      Resend
                    </button>
                  }
                        {/* <button 
                            className="resend-btn"
                            onClick={handleResendOtp}
                            disabled={!isResendMobileOtp || loading}
                            style={{
                                color: "blue",
                                fontSize: 14,
                                borderBottom: '1px solid blue',
                              }}
                        >
                            Resend OTP
                        </button> */}
                        <span>{resendTimer > 0 ? `Retry in ${resendTimer} seconds` : ""}</span>
                    </div>
                )}
                {isOtpSent && !isResendMobileOtp && (
                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                        <p>Resend OTP in {resendTimer} seconds</p>
                    </div>
                )}

                <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn">
                    {loading ? <LoadingIcon
                        style={{
                            height: 50,
                            width: '100%'
                        }}
                    /> : <button
                        className="theme-btn style-four"
                        type="Login"
                        name="submit-form"
                        disabled={loading} // Disable button while loading
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        Login
                    </button>}
                </div>
            </div>
            <div className="d-flex justify-content-center w-100 mt-3">
          {/* onClick={() => setIsSignUp(!isEnquiry)} */}
          <h6 onClick={() => { handleIsEnquiry('register') }} style={{ color: "darkblue", textDecoration: "underline", cursor: "pointer" }}>Create an account</h6>
        </div>
        </form>
    );
}
